import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ErrorService } from '../../../error';
import { WorkScheduleModel } from './types';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../../service/message/types';
import { MessageService } from '../../../service/message/message.service';

@Injectable({
  providedIn: 'root',
})
export class WorkScheduleApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<WorkScheduleModel> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.get<WorkScheduleModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<WorkScheduleModel> => {
    let url = this.formatUrl(['create']);
    return this.httpClient.get<WorkScheduleModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  add = (
    workScheduleModel: WorkScheduleModel,
  ): Observable<WorkScheduleModel> => {
    let url = this.formatUrl([]);
    return this.httpClient
      .post<WorkScheduleModel>(url, workScheduleModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (
    workScheduleModel: WorkScheduleModel,
  ): Observable<WorkScheduleModel> => {
    let url = this.formatUrl([workScheduleModel.id.toString()]);
    return this.httpClient
      .put<WorkScheduleModel>(url, workScheduleModel, { observe: 'response' })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  delete = (id: number): Observable<boolean> => {
    let url = this.formatUrl([id.toString()]);
    return this.httpClient.delete<boolean>(url, { observe: 'response' }).pipe(
      this.messageService.checkStatusCustomOperator(CrudType.delete),
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.workSchedule.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
